import DisableMFA from './DisableMFA'

export default DisableMFA
